module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"title":"Доступные объекты","amount":"кол-во"},"en":{"title":"Available objects","amount":"amount"}}')
  delete Component.options._Ctor
}
